import { useCallback } from "react";

/** Must match the `2.4s` in CallBarGlow.module.css and PacingCountdownPill.module.css; spec asserts both. */
export const PACING_PULSE_DURATION_MS = 2400;

/**
 * Phase-anchors an element's pulse to a shared clock so the pill and the glow bar pulse in lockstep
 * despite starting at different times. An `animation-delay` of `-(now % duration)` lands every
 * element at the same phase whenever it mounted. The ref identity must stay stable across the
 * per-second re-renders, or React re-invokes it and re-anchors mid-cycle.
 */
export function usePacingPulseSync(active: boolean): (el: HTMLElement | null) => void {
    return useCallback(
        (el: HTMLElement | null) => {
            if (!el) return;
            el.style.animationDelay = active ? `${-(globalThis.performance.now() % PACING_PULSE_DURATION_MS)}ms` : "";
        },
        [active],
    );
}
